/**
 * Tijden in Amsterdamse tijd voor de werkplek. Kwam uit de map van motor
 * 6.1 (sessie 105); verhuisd naar gedeeld in sessie 8D, werking gelijk.
 */

const TZ = "Europe/Amsterdam";

const dagDelen = new Intl.DateTimeFormat("nl-NL", {
  timeZone: TZ,
  weekday: "short",
  day: "2-digit",
  month: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

const klokFmt = new Intl.DateTimeFormat("nl-NL", {
  timeZone: TZ,
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

function geldig(moment: string | null | undefined): Date | null {
  if (!moment) return null;
  const d = new Date(moment);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "di 07-10, 08:14" (Amsterdamse tijd). Leeg moment: "onbekend". */
export function dagTijd(moment: string | null | undefined): string {
  const d = geldig(moment);
  if (!d) return "onbekend";
  const p = Object.fromEntries(
    dagDelen.formatToParts(d).map((x) => [x.type, x.value]),
  );
  const dag = String(p.weekday ?? "").replace(/\.$/, "");
  return `${dag} ${p.day}-${p.month}, ${p.hour}:${p.minute}`;
}

/** "08:14" (Amsterdamse tijd). */
export function klok(moment: string | null | undefined): string {
  const d = geldig(moment);
  return d ? klokFmt.format(d) : "onbekend";
}

/** "bijgewerkt 10:52". */
export function bijgewerkt(moment: string | null | undefined): string {
  return `bijgewerkt ${klok(moment)}`;
}
